import { cn } from "@/lib/utils";
import NamedIcon from "components/icons/NamedIcon";

const TableIconBadge = ({ iconName, smallIcon = false, className }) => (
  <span
    className={cn(
      "tw:inline-flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary tw:text-primary-foreground",
      smallIcon ? "tw:size-6" : "tw:size-8",
      className
    )}
    aria-hidden="true"
  >
    <NamedIcon
      name={iconName}
      className={smallIcon ? "tw:size-3.5" : "tw:size-4"}
    />
  </span>
);

export default TableIconBadge;
